GloboSwatchConfig.settings = {
            enable_collection_page: true,
            enable_product_page: true,
            out_of_stock: "cross out",
            enable_mandatory: false,
            show_add_to_cart_button: true,
            add_to_cart_ajax: false,
            show_option_name: true,
            add_to_cart_text: "Add to cart",
            added_to_cart_text: "Added to cart",
            sold_out_text: "Sold out",
            text_required: "This field is required",
            sort_option: false,
            show_one_variant_product: false,
            show_one_variant_collection: false,
            group_image: true,
            show_limit_variant: false,
            limit_variant: "5",
        };
        GloboSwatchConfig.options = [{"id":73994,"name":"Title","shop_id":12933,"option_items":[{"id":1837585,"value":"Default Title","option_id":73994,"products":null,"products_count":5,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":3,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":null,"products_count":5,"order":1},{"id":73995,"name":"Size","shop_id":12933,"option_items":[{"id":1837586,"value":"S","option_id":73995,"products":null,"products_count":4,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1837587,"value":"M","option_id":73995,"products":null,"products_count":4,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1837588,"value":"L","option_id":73995,"products":null,"products_count":4,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1837589,"value":"XL","option_id":73995,"products":null,"products_count":4,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1837590,"value":"XXL","option_id":73995,"products":null,"products_count":4,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":3,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":null,"products_count":4,"order":2},{"id":73996,"name":"Color","shop_id":12933,"option_items":[{"id":1837591,"value":"Red","option_id":73996,"products":null,"products_count":4,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1837592,"value":"Green","option_id":73996,"products":null,"products_count":4,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1837593,"value":"Yellow","option_id":73996,"products":null,"products_count":3,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1837594,"value":"Blue","option_id":73996,"products":null,"products_count":4,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":2,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":null,"products_count":4,"order":3}];
        GloboSwatchConfig.product_page= {
                customize_swatch: {
                    swatch_shape: 'square',
                    swatch_size: 'large',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#000000',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#FFFFFF',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                show_number_stock: '',
                float: 'left'
            };
            GloboSwatchConfig.collection_page ={
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#0a0a0a',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#ffffff',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                float: 'left',
                carousel: 'disable'
        };